import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import {
    Box,
    Tooltip
} from '@mui/material';
import Skeleton from '@material-ui/lab/Skeleton';
import EditIcon from '@mui/icons-material/Edit';
//Icons Imports
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import ScheduleIcon from '@mui/icons-material/Schedule';

import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';

import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import HomeIcon from '@mui/icons-material/Home';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ReactApexChart from 'react-apexcharts';

import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import moment from 'moment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';

import { parseISO } from 'date-fns';

import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import PersonIcon from '@mui/icons-material/Person';
import { Card, CardContent, Typography } from '@mui/material';
import { ArrowUpward, ArrowDownward, MoreVert, AttachMoney, ShoppingBasket } from '@mui/icons-material';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';



import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
 




const styles = {
    card: {
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '200px',
    },
    purpleCard: {
        backgroundColor: '#6a1b9a',
        color: '#fff',
    },
    blueCard: {
        backgroundColor: '#0288d1',
        color: '#fff',
    },
    iconBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    iconBackground: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        padding: '8px',
    },
    graphBox: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        height: '40px',
        marginTop: '8px',
    },

};


export default function FluxoCaixa() {



    const [loading, setLoading] = useState(true);

    const [objetos, setObjetos] = useState(null);

    const [value, setValue] = useState(1);

    const [totalRegistros, setTotalRegistros] = useState(0);

    const [filtro, setFiltro] = useState('');

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 1000,
    });

    const [estatisticas, setEstatisticas] = useState({
        numDespesas: 0,
        numReceitas: 0,
        valorTotalDespesa: 0,
        valorTotalReceita: 0,

    });



    function calcularEstatisticas(filteredRows) {

        const stats = filteredRows.reduce(
            (acc, pagamento) => {
                const valor = Number(pagamento.valor) || 0;


                if (pagamento.tipo_lancamento === 0) {
                    acc.numDespesas += 1;
                    acc.valorTotalDespesa += valor;

                } else if (pagamento.tipo_lancamento === 1) {
                    acc.numReceitas += 1;
                    acc.valorTotalReceita += valor;

                }

                return acc;
            },
            {
                numDespesas: 0,
                numReceitas: 0,
                valorTotalDespesa: 0,
                valorTotalReceita: 0,

            }
        );

        setEstatisticas(stats);
    }


    async function listarFluxoCaixa() {

        setLoading(true);

        try {
            const token = Cookies.get('token');
            const id_usuario = Cookies.get('id_usuario');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const regra = Cookies.get('regra');
            if (regra.includes("ADMIN")) {

                let response2 = await api.get(`v1/protected/financeiro/pagamentos/listartodossimples?busca=${filtro}&size=${pagination.pageSize}&page=${pagination.pageIndex}`, { headers });

                setObjetos(response2.data.dados); // você deve retornar os dados paginados como { dados: [...], total: X }
                calcularEstatisticas(response2.data.dados);
                setTotalRegistros(response2.data.total);
                setLoading(false);

            }

        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }





    useEffect(() => {
        listarFluxoCaixa();
    }, [pagination.pageIndex, pagination.pageSize]);




    const [totalDespesas, setTotalDespesas] = useState(0.0);
    const [totalReceitas, setTotalReceitas] = useState(0.0);

    const [totalDespesasMesAtual, setTotalDespesasMesAtual] = useState(0.0);
    const [totalDespesasPagoMesAtual, setTotalDespesasPagoMesAtual] = useState(0.0);
    const [totalDespesasAPagarMesAtual, setTotalDespesasAPagarMesAtual] = useState(0.0);


    const [totalDespesasHoje, setTotalDespesasHoje] = useState(0.0);
    const [totalReceitasHoje, setTotalReceitasHoje] = useState(0.0);


    const [totalReceitasMesAtual, setTotalReceitasMesAtual] = useState(0.0);
    const [totalReceitasPagoMesAtual, setTotalReceitasPagoMesAtual] = useState(0.0);
    const [totalReceitasAPagarMesAtual, setTotalReceitasAPagarMesAtual] = useState(0.0);



    const dataAtual = new Date();
    const mesAtual = dataAtual.toLocaleString('default', { month: 'long' });
    const anoAtual = dataAtual.getFullYear();



    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });



    const [dadosGrafico, setDadosGrafico] = useState({
        series: [
            { name: 'Receitas', data: [] },
            { name: 'Despesas', data: [] },


        ],
        options: {
            chart: {
                height: '100%',
                type: 'bar',
                width: '100%',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '100%',
                    endingShape: 'rounded'

                },
            },
            colors: ['#0288d1', '#6a1b9a'],
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: {
                categories: [],
            },
            yaxis: {
                title: {
                    text: 'Valores',
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return currencyFormatter.format(val);
                    }
                }
            }
        }
    });






    const columns = useMemo(
        () => [
            {
                accessorKey: 'id_pagamento',
                header: 'ID',
                size: 50,
                accessorFn: row => row.id_pagamento, // garante que filtro funcione
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        {cell.getValue()}
                    </span>
                ),
            },
            {
                accessorKey: 'data_pagamento',
                header: 'Data',
                size: 130,
                accessorFn: row => row.data_pagamento, // valor bruto no formato ISO ou timestamp
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <CalendarTodayIcon fontSize="small" color="action" />
                        {moment(cell.getValue()).format('DD/MM/YYYY')}
                    </span>
                ),
                filterVariant: 'range', // 🔹 ativa range de valores
                filterFn: (row, id, filterValue) => {
                    const cellValue = moment(row.getValue(id));
                    const [start, end] = filterValue || [];

                    if (start && cellValue.isBefore(moment(start), 'day')) return false;
                    if (end && cellValue.isAfter(moment(end), 'day')) return false;

                    return true;
                },
            },
            {
                accessorKey: 'valor',
                header: 'Valor',
                size: 150,
                accessorFn: row => row.valor,
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <AttachMoneyIcon fontSize="small" color="success" />
                        {currencyFormatter.format(cell.getValue())}
                    </span>
                ),
            },
            {
                accessorKey: 'tipo_lancamento',
                header: 'Tipo',
                size: 130,
                accessorFn: row => {
                    switch (row.tipo_lancamento) {
                        case 0: return 'DESPESA';
                        case 1: return 'RECEITA';
                        case 2: return 'EMPRÉSTIMO';
                        case 3: return 'TRANSFERÊNCIA';
                        default: return '';
                    }
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue(); // agora vem como string (ex: "DESPESA")

                    if (value === 'DESPESA')
                        return <><PaymentIcon color="error" fontSize="small" /> {value}</>;
                    if (value === 'RECEITA')
                        return <><AttachMoneyIcon color="success" fontSize="small" /> {value}</>;
                    if (value === 'EMPRÉSTIMO')
                        return <><HandshakeIcon color="primary" fontSize="small" /> {value}</>;
                    if (value === 'TRANSFERÊNCIA')
                        return <><SwapHorizIcon color="warning" fontSize="small" /> {value}</>;

                    return null;
                },
            },
            {
                accessorKey: 'status',
                header: 'Status',
                size: 130,
                accessorFn: row => {
                    if (row.status === 0) return 'NÃO PAGO';
                    if (row.status === 1) return 'PAGO';
                    return '';
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue(); // agora vem "NÃO PAGO" ou "PAGO"

                    if (value === 'NÃO PAGO')
                        return <><CancelIcon color="error" fontSize="small" /> {value}</>;
                    if (value === 'PAGO')
                        return <><CheckCircleIcon color="success" fontSize="small" /> {value}</>;

                    return null;
                },
            },
            {
                accessorKey: 'centro_custo',
                header: 'Centro de Custo',
                size: 150,
                accessorFn: row => row.centro_custo,
                Cell: ({ renderedCellValue }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <CategoryIcon fontSize="small" color="action" />
                        {renderedCellValue}
                    </span>
                ),
            },
            {
                accessorKey: 'metodo_pagamento',
                header: 'Método Pag.',
                size: 150,
                accessorFn: row => row.metodo_pagamento,
                Cell: ({ renderedCellValue }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <AccountBalanceIcon fontSize="small" color="action" />
                        {renderedCellValue}
                    </span>
                ),
            },

            // 🔹 Pagador
            {
                accessorKey: 'pagador',
                header: 'Pagador',
                size: 300,
                accessorFn: row => row.pagador || '', // garante string pro filtro
                Cell: ({ cell }) => {
                    const valor = cell.getValue()?.toString() || '';
                    const onlyNumbers = valor.replace(/\D/g, '');
                    const isCpfCnpj = onlyNumbers.length === 11 || onlyNumbers.length === 14;
                    const isBanco = valor.toUpperCase().includes('BANCO');

                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            {isCpfCnpj && <PersonIcon fontSize="small" color="action" />}
                            {isBanco && <AccountBalanceIcon fontSize="small" color="action" />}
                            {!isCpfCnpj && !isBanco && <CategoryIcon fontSize="small" color="action" />}
                            {valor}
                        </span>
                    );
                },
            },

            // 🔹 Recebedor
            {
                accessorKey: 'recebedor',
                header: 'Recebedor',
                size: 300,
                accessorFn: row => row.recebedor || '',
                Cell: ({ cell }) => {
                    const valor = cell.getValue()?.toString() || '';
                    const onlyNumbers = valor.replace(/\D/g, '');
                    const isCpfCnpj = onlyNumbers.length === 11 || onlyNumbers.length === 14;
                    const isBanco = valor.toUpperCase().includes('BANCO');

                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            {isCpfCnpj && <PersonIcon fontSize="small" color="action" />}
                            {isBanco && <AccountBalanceIcon fontSize="small" color="action" />}
                            {!isCpfCnpj && !isBanco && <CategoryIcon fontSize="small" color="action" />}
                            {valor}
                        </span>
                    );
                },
            },
        ],
        []
    );




    function handleClickGerenciar(row) {
        const idLancamento = row.original.id_lancamento;
        const url = `/gestao/financas/lancamento/gerenciar/${idLancamento}`;
        window.location.href = url;
    }




     const table = useMaterialReactTable({
    columns,
    data: objetos,
    enableBottomToolbar: true,
    enableGlobalFilterModes: true,
    enableRowActions: true,
    manualPagination: true,
    onPaginationChange: setPagination,
    rowCount: totalRegistros,
    state: { pagination },
    enableStickyHeader: true,
    paginationDisplayMode: "pages",
    getRowId: (row) => row.id_pagamento,
    enableGrouping: true,
    initialState: {
      showGlobalFilter: true,
      showColumnFilters: true,
    },
    muiTableContainerProps: { sx: { maxHeight: "1000px" } },
    muiPaginationProps: {
      rowsPerPageOptions: [1000, 2000, 10000],
      variant: "outlined",
    },
    enableFullScreenToggle: true,
    renderDetailPanel: ({ row }) => (
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-around",
          left: "30px",
          maxWidth: "1000px",
          position: "sticky",
          width: "100%",
        }}
      />
    ),
    renderRowActions: ({ row }) => (
      <Box sx={{ display: "flex", gap: "1rem", flexDirection: "row", alignItems: "center" }}>
        <Tooltip title="Gerenciar">
          <IconButton color="error" onClick={() => handleClickGerenciar(row)}>
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    muiTableHeadCellProps: {
      sx: {
        fontSize: "0.8rem",
        padding: "6px 8px",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        fontSize: "0.75rem",
        padding: "2px 6px",
      },
    },
    muiTableBodyRowProps: {
      sx: {
        minHeight: "24px",
      },
    },
    localization: MRT_Localization_PT_BR,
    onStateChange: (tableState) => {
      if (!table) return;
      const filteredRows = table.getFilteredRowModel().rows.map((row) => row.original);
      calcularEstatisticas(filteredRows);
    },
  });




    return (


        <div >
            <Box
                sx={{
                    mb: 3,
                    display: "flex",
                    flexDirection: "column",
                    pl: 2,
                    pr: 2,
                    gap: 2, // espaçamento entre título/botão e estatísticas
                }}
            >
                {/* Cabeçalho */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <PaymentsIcon color="primary" />
                        <Typography
                            variant="h6"
                            component="h1"
                            fontWeight="bold"
                            color="primary"
                        >
                            Fluxo de Caixa
                        </Typography>

                        
                    </Box>

                 
                </Box>

                <Grid container spacing={1}>
                    {/* Linha Despesas */}
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={1}>
                            <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <MoneyOffIcon color="error" sx={{ fontSize: 14 }} />
                                <Typography variant="caption" fontWeight="bold">
                                    {estatisticas?.numDespesas || 0} Despesas
                                </Typography>
                            </Paper>
                            <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <TrendingDownIcon color="error" sx={{ fontSize: 14 }} />
                                <Typography variant="caption" fontWeight="bold">
                                    {currencyFormatter.format(estatisticas.valorTotalDespesa)}
                                </Typography>
                            </Paper>
                           
                          
                        </Stack>
                    </Grid>

                    {/* Linha Receitas */}
                    <Grid item xs={12}>
                        <Stack direction="row" spacing={1}>
                            <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <AttachMoneyIcon color="success" sx={{ fontSize: 14 }} />
                                <Typography variant="caption" fontWeight="bold">
                                    {estatisticas?.numReceitas || 0} Receitas
                                </Typography>
                            </Paper>
                            <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                <TrendingUpIcon color="success" sx={{ fontSize: 14 }} />
                                <Typography variant="caption" fontWeight="bold">
                                    {currencyFormatter.format(estatisticas.valorTotalReceita)}
                                </Typography>
                            </Paper>
                          
                            
                        </Stack>
                    </Grid>
                </Grid>

            </Box>
            {loading ?
                <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                </Skeleton>
                :

                <div>
                    <div style={{ backgroundColor: 'white' }}>
                        {objetos !== null && (
                            <>
  <MaterialReactTable table={table} />
                              


                            </>
                        )}
                    </div>
                </div>
            }


        </div>

    );
}



